import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Motion";
import { IMAGES } from "@/data";

const POINTS = ["Recent nearby sales", "Property condition & upgrades", "Current market competition", "Your goals & timeline"];

export default function Sell() {
  return (
    <div className="bg-cream pt-24">
      <section className="px-6 md:px-12 py-16 md:py-24">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <Reveal><p className="font-mono text-xs uppercase tracking-[0.3em] text-green mb-4">For Sellers</p></Reveal>
            <Reveal delay={0.1}><h1 className="font-serif text-5xl md:text-6xl text-navy tracking-tighter leading-[0.95] mb-6">Thinking about selling? Start with a local home-value review.</h1></Reveal>
            <Reveal delay={0.2}><p className="text-lg text-charcoal/75 mb-8 max-w-lg">Receive a personalized review based on your property, recent nearby sales, condition, upgrades, and current market competition.</p></Reveal>
            <Reveal delay={0.3}>
              <Link to="/sell/questionnaire" data-testid="sell-start-quiz" className="bg-gold text-navy font-semibold px-8 py-4 rounded-full hover:scale-105 transition-transform inline-flex items-center gap-2">
                See My Selling Potential <ArrowUpRight size={18} />
              </Link>
            </Reveal>
          </div>
          <Reveal delay={0.2}><img src={IMAGES.home2} alt="Home exterior" className="rounded-[2rem] shadow-2xl w-full h-[420px] object-cover" /></Reveal>
        </div>
      </section>

      <section className="px-6 md:px-12 py-20 bg-white">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <Reveal><h2 className="font-serif text-4xl md:text-5xl text-navy tracking-tight">What your review considers</h2></Reveal>
          <Reveal delay={0.1}>
            <ul className="space-y-4">
              {POINTS.map((p, i) => (
                <li key={p} className="flex items-center gap-4 bg-cream rounded-2xl p-5 border border-black/5">
                  <span className="font-serif text-2xl text-gold">0{i + 1}</span>
                  <span className="text-charcoal/80 text-lg">{p}</span>
                </li>
              ))}
            </ul>
            <p className="text-xs text-charcoal/50 mt-6">This is not an exact home value. An agent-prepared market analysis (CMA) is required for a more complete estimate.</p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
